import nvSharedModelsModule from '../nv.shared.models.module';

angular.module(nvSharedModelsModule).service('ClusterResource', function($http, $resource, PublicConfig, $rootScope) {
  let Cluster = $resource(PublicConfig.NV_API_ORIGIN + '/v1/schools');

  Cluster.get().$promise.then(
    function(clusterData) {
      $rootScope.clusterSchools = clusterData.data;
      return clusterData;
    },
    function(err) {
      // TODO handle err
      return err;
    },
  );

  return Cluster;
});
